import { API_ENDPOINTS } from '../../../constants/api';
import { getWebAppOriginForStripeBillingRedirects } from '../../accounts/helpers/consumerBillingWebOrigin.helper';

type ApiClient = (endpoint: string, options?: Record<string, unknown>) => Promise<{ status: number; data: unknown }>;

export async function createProEmbeddedCheckoutSession(
  apiClient: ApiClient,
  billingInterval: 'month' | 'year',
): Promise<{ clientSecret: string; sessionId: string }> {
  const webAppOrigin = getWebAppOriginForStripeBillingRedirects();
  const response = await apiClient(API_ENDPOINTS.billing.consumerProEmbeddedCheckoutSession, {
    method: 'POST',
    data: { billingInterval, ...(webAppOrigin != null ? { webAppOrigin } : {}) },
  });
  const body = response.data as { success?: boolean; data?: { clientSecret?: string; sessionId?: string }; error?: string };
  if (response.status >= 400 || !body.success || !body.data?.clientSecret || !body.data?.sessionId) {
    throw new Error(body.error ?? 'Failed to create Pro checkout session');
  }
  return { clientSecret: body.data.clientSecret, sessionId: body.data.sessionId };
}

export async function syncProRevenueCat(
  apiClient: ApiClient,
  action: 'grant' | 'revoke' = 'grant',
): Promise<void> {
  await apiClient(API_ENDPOINTS.billing.consumerProRevenueCatSync, {
    method: 'POST',
    data: { action },
  });
}
